import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import Button from './Button';
import { SvgIcon } from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import breakpoints from 'theme/material/breakpoints';
import colors from 'theme/colors';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const StyledCancelButton = styled(Button)(
  {
    fontSize: '14px !important',
    fontWeight: 600,
    borderRadius: '6px !important',
    display: 'flex !important',
    alignContent: 'center !important',
    alignItems: 'center !important',
    padding: '12px !important',
    height: 32,
    cursor: 'pointer',
    lineHeight: '16px !important',
  },
  ({ isTextType }) =>
    isTextType && {
      [breakpoints.down(620.05)]: {
        border: '0px !important',
        paddingRight: '0px !important',
        marginBottom: '0px !important',
        ':hover': {
          border: 'none !important',
          backgroundColor: 'transparent !important',
          color: `${colors.red[400]} !important`,
        },
        ':focus': {
          backgroundColor: 'inherit !important',
          color: colors.red[500],
          border: 'inherit',
        },
      },
    }
);

const closeButton = {
  fontSize: 32,
  cursor: 'pointer',
};

interface CancelButtonProps {
  handleCancel(): void;
  dataTestId: string;
  customStyle: any;
  isTextType?: boolean;
}

const CancelButton = ({
  handleCancel,
  dataTestId,
  customStyle,
  isTextType = false,
}: CancelButtonProps): ReactElement => {
  const { isMobile } = useMediaBreakpoints();

  return (
    <StyledCancelButton
      data-test-id={dataTestId}
      onClick={handleCancel}
      customStyle={customStyle}
      buttonType="secondaryRed"
      buttonTextCustomStyle={isMobile ? { display: 'flex', alignContent: 'center', alignItems: 'center' } : {}}
      isTextType={isTextType}
    >
      <SvgIcon component={CloseOutlined} style={closeButton} />
      Cancel
    </StyledCancelButton>
  );
};

CancelButton.defaultProps = {
  handleCancel: () => null,
  dataTestId: '',
  customStyle: {},
};

export default CancelButton;
